import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "toggle"]

  connect() {
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
    this.closeOnEscape = this.closeOnEscape.bind(this)
    // Cache the menu element directly — once it's reparented to document.body,
    // Stimulus can no longer find it via this.menuTarget
    this.menu = this.menuTarget
    this.originalParent = this.menu.parentElement
    this.originalNextSibling = this.menu.nextElementSibling
  }

  toggle() {
    if (this.menu.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    const menu = this.menu
    const button = this.toggleTarget
    const rect = button.getBoundingClientRect()

    // Move menu to body so it escapes all stacking contexts
    document.body.appendChild(menu)

    menu.classList.remove("hidden")
    menu.style.position = "fixed"
    menu.style.zIndex = "9999"

    // Check if sidebar is collapsed (narrow) — position to the right
    const sidebar = this.element.closest("[data-nav-sidebar-target='sidebar']")
    const collapsed = sidebar && sidebar.classList.contains("w-16")

    if (collapsed) {
      menu.style.left = `${rect.right + 8}px`
      menu.style.bottom = `${window.innerHeight - rect.bottom}px`
    } else {
      menu.style.left = `${rect.left}px`
      menu.style.bottom = `${window.innerHeight - rect.top + 4}px`
      menu.style.width = `${rect.width}px`
    }

    document.addEventListener("click", this.closeOnOutsideClick)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  close() {
    const menu = this.menu
    menu.classList.add("hidden")
    menu.style.position = ""
    menu.style.zIndex = ""
    menu.style.left = ""
    menu.style.bottom = ""
    menu.style.width = ""

    // Move menu back to its original position in the DOM
    if (this.originalNextSibling) {
      this.originalParent.insertBefore(menu, this.originalNextSibling)
    } else {
      this.originalParent.appendChild(menu)
    }

    document.removeEventListener("click", this.closeOnOutsideClick)
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  closeOnOutsideClick(event) {
    if (
      !this.element.contains(event.target) &&
      !this.menu.contains(event.target)
    ) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick)
    document.removeEventListener("keydown", this.closeOnEscape)
  }
}
